import { useEffect } from "react";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import App from "./App";
import Maps from "./pages/maps";
import { ThemeProvider } from "styled-components";
import usePersistedState from "./utils/usePersistedState";
import light from "./styles/themes/light";
import GlobalStyle from "./styles/global";
import Header from "./components/Header/header";
import { DataProvider } from "./context/DataContext";

export default function MainRoutes() {
  const [theme] = usePersistedState("theme", light);

  return (
    <BrowserRouter>
      <DataProvider>
        <ThemeProvider theme={theme}>
          <GlobalStyle />
          <Header />
          <LocationWatcher />
          <Routes>
            <Route path="/" element={<Maps />} />
            <Route path="/card" element={<App />} />
          </Routes>
        </ThemeProvider>
      </DataProvider>
    </BrowserRouter>
  );

  function LocationWatcher() {
    const location = useLocation();

    useEffect(() => {
      if (location.pathname === "/") {
        document.body.style.overflowY = "hidden";
      } else if (location.pathname === "/card") {
        document.body.style.overflowY = "scroll";
      }
    }, [location]);

    return null;
  }
}
